import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  const setErrorState = (errorMessage) => setError(errorMessage);
  const clearError = () => setError(null);

  const login = (userData) => setUser(userData);
  const logout = () => setUser(null);

  return (
    <UserContext.Provider value={{ user, login, logout, error, setErrorState, clearError }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);